import classNames from 'classnames'
import _ from 'lodash'
import React from 'react'
import { Popover, PopoverInteractionKind } from '@blueprintjs/core'

import { IBaseProps } from 'browser/components/atomic-elements/atoms/base-props'
import 'browser/components/atomic-elements/atoms/label/_label.scss'
import { translateString } from 'shared-libs/helpers/utils'
import { FramesManager } from 'shared-libs/components/view/frames-manager'

/**
 * @uiComponent
 */
export interface ILabelProps extends IBaseProps {
  id?: string
  frames?: FramesManager
  hasError?: boolean
  isHorizontalLayout?: boolean
  isOptional?: boolean
  isRequired?: boolean
  isSecondary?: boolean
  isReadOnly?: boolean
  // TODO(peter/louis): need to look at this. Only made this that I could use the property in json.
  text?: string
  size?: string
  multiLine?: boolean
  widthClassName?: string
  tooltip?: React.ReactNode
}

export class Label extends React.Component<ILabelProps, any> {
  public static defaultProps: ILabelProps = {
    children: [],
    isOptional: false,
    multiLine: true,
    widthClassName: '',
  }

  public render() {
    const {
      id,
      widthClassName,
      className,
      isHorizontalLayout,
      isRequired,
      isSecondary,
      isOptional,
      hasError,
      multiLine,
      size,
      isReadOnly
    } = this.props
    let sizeClassName
    const contentWidthClassName = isHorizontalLayout ? widthClassName : ''

    if (isHorizontalLayout && !_.isEmpty(size)) {
      sizeClassName = `c-label--${size}`
    }

    const content = this.getLabelContent()
    return (
      <label
        id={id}
        className={classNames('c-label', contentWidthClassName, sizeClassName, className, {
          'c-label--error': hasError,
          'c-label--isHorizontal': isHorizontalLayout,
          'c-label--isOptional': isOptional,
          'c-label--isRequired': isRequired,
          'c-label--secondary': isSecondary,
          'c-label--isReadOnly': isReadOnly,
          'u-ellipsis': !multiLine,
        })}
      >
        {content}
      </label>
    )
  }

  private getLabelContent() {
    const { children, frames, tooltip, text } = this.props

    const translationTable = frames?.getContext('translationTable')
    const translatedText = translateString(text, translationTable)

    // Note that if children == null, then the CSS will automatically
    // display:none the label element.
    const content = _.isEmpty(children) ? translatedText : children

    if (_.isEmpty(tooltip)) {
      return content
    } else {
      return (
        <Popover
          fill={false}
          interactionKind={PopoverInteractionKind.HOVER}
          content={<div className={'c-label-tooltip'}>{tooltip}</div>}
        >
          <span tabIndex={0} className={classNames('c-label--withTooltip')}>
            {content}
          </span>
        </Popover>
      )
    }
  }
}
